import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	CardBody,
	Card,
	CardHeader,
	Row,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import AddEditProductiveCycleStageTemplateModal from './Add_Edit/AddEditProductiveCycleStageTemplate';
import DeleteProductiveCycleStageTemplateModal from './Delete/DeleteProductiveCycleStageTemplate';

import { ODataGrid } from '../../Components/OElements/ODataGrid';
import { getProductiveCycleStageTemplateList } from '../../slices/thunks';

const ProductiveCycleStageTemplateList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorCategories = createSelector(
		state => state.ProductiveCycleStageTemplate,
		data => ({
			dataList: data.itemProductiveCycleStageTemplateList,
			isLoadingList: data.isLoadingList,
			isProductiveCycleStageTemplateSuccess: data.isProductiveCycleStageTemplateSuccess,
			error: data.error,
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isAddError: data.isAddError,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isUpdateError: data.isUpdateError,
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { dataList, isLoadingList } = useSelector(selectorCategories);

	useEffect(() => {
		dispatch(getProductiveCycleStageTemplateList());
	}, []);

	const [dataProductiveCycleStageTemplate, setDataProductiveCycleStageTemplate] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete ProductiveCycleStageTemplate
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataProductiveCycleStageTemplate(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataProductiveCycleStageTemplate(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'categories',
				columnDefType: 'display',

				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Etapa', accessorKey: 'productive_cycle_stage.name', size: 'auto', },
			{ header: 'Días', accessorKey: 'days', size: 'auto', },
			{ header: 'Especie', accessorKey: 'species.name', size: 'auto', },
			{ header: 'Región', accessorKey: 'region.name', size: 'auto', },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataProductiveCycleStageTemplate({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Etapa de Ciclo Productivo
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={dataList || []}
								isLoadingData={isLoadingList}
								nameFile={'etapas_del_ciclo_productivo'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataProductiveCycleStageTemplate({});
											handleToggleModal();
										},
										title: 'Crear Etapa de Ciclo Productivo'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditProductiveCycleStageTemplateModal
				dataProductiveCycleStageTemplate={dataProductiveCycleStageTemplate}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteProductiveCycleStageTemplateModal
				dataProductiveCycleStageTemplate={dataProductiveCycleStageTemplate}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ProductiveCycleStageTemplateList;
